import styles from './HeroSearch.module.scss';
import React from 'react';

import {CaptchaModal} from 'components/Captcha';
// import DataLayerPush from 'utils/gtm';
import {useHistory} from 'react-router-dom';
import {queryStringify} from 'utils/http';
import SingleSearchInputPublic from 'modules/advanced-search/AdvancedSearchInputPublic';

function HeroSearch() {
  // const {eventSearchClick, eventSearchInput} = DataLayerPush;
  const history = useHistory();

  function onSubmit(data) {
    history.push({
      pathname: '/search/certified-entities',
      search: queryStringify(data),
    });
  }

  return (
    <CaptchaModal initialCheck={false}>
      {({verifyCaptcha, isVerified}) => {
        return (
          <div className={styles['search']}>
            <SingleSearchInputPublic
              verifyCaptcha={verifyCaptcha}
              onSubmit={onSubmit}
              name="search"
            />
          </div>
        );
      }}
    </CaptchaModal>
  );
}

export default HeroSearch;
